(function () {
  'use strict';

  function getTagsTemplate(tags) {
    if (!tags) {
      return '';
    }
    
    // Handle case where tags might be a comma-separated string instead of array
    var tagArray;
    if (typeof tags === 'string') {
      // Split by comma and trim each tag
      tagArray = tags.split(',').map(function(tag) { 
        return tag.trim(); 
      }).filter(function(tag) { 
        return tag.length > 0; 
      });
    } else if (Array.isArray(tags)) {
      tagArray = tags;
    } else {
      return '';
    }
    
    var tagsTemplate = `
        <div class="mdl-card__supporting-text">
             `;
    if (fixtures.currentAI && fixtures.currentAI.user__username) {
      var urlencoded_username = encodeURIComponent(
        fixtures.currentAI.user__username
      );
      tagsTemplate += `<div class="mdl-chip">
    <span class="mdl-chip__text"><a href="/p/${urlencoded_username}" target="_blank" data-bypass>${fixtures.currentAI.user__username}</a></span></div>`;
    }
    for (var i = 0; i < tagArray.length; i++) {
      var currentTag = tagArray[i];
      var urlEncodedTag = encodeURIComponent(currentTag);
      var currentTagDisplay = currentTag;
      if (currentTag.length > 20) {
        currentTagDisplay = currentTag.substring(0, 20) + '...';
      }
      currentTag = currentTag.trim();
      if (currentTag) {
        tagsTemplate += `<div class="mdl-chip">
    <span class="mdl-chip__text"><a href="/ai-chatbots?category=${urlEncodedTag}" target="_blank" data-bypass>${currentTag}</a></span></div>`;
      }
    }
    tagsTemplate += `</div>`;
    return tagsTemplate;
  }

  function populateElfStyles() {
    var container = document.getElementById('elf-styles-container');
    if (!container || !window.fixtures || !window.fixtures.hardcoded_json) {
      console.log('Elf styles container or data not found');
      return;
    }

    container.innerHTML = '';

    window.fixtures.hardcoded_json.forEach(function (style) {
      var styleDiv = document.createElement('div');
      styleDiv.className =
        'ai-categories mdl-cell mdl-cell--1-col mdl-cell--stretch';

      styleDiv.innerHTML = `
                <span class="mdl-list__item-primary-content" onclick="return addGenerationCat('${style.title_name}')">
                    <span class="avatar-category">
                        <img loading="lazy" class="ai-avatar-icon" src="${style.image_url}" alt="${style.title_name}">
                    </span>
                    <span class="ai-example center-desc category-capped ai-name mdl-chip__text mdl-chip search-cat-chip">${style.title_name}</span>
                </span>
            `;

      container.appendChild(styleDiv);
    });
  }

  window.TemplateUtils = {
    getTagsTemplate: getTagsTemplate,
    populateElfStyles: populateElfStyles,
  };
})();
